import styled from '@emotion/styled';
import { Accordion } from '@mui/material';

export const Container = styled(Accordion)`
  &.MuiPaper-root {
    margin: 0;
  }
`;
